/**
 * When `t(key)` has no DB translation, LanguageProvider returns `key` unchanged.
 * Use a human-readable fallback so UI never shows raw key paths.
 */
export function tWithFallback(
  t: (key: string, params?: Record<string, string | number>) => string,
  key: string,
  fallback: string
): string {
  const v = t(key);
  return v === key ? fallback : v;
}
